import Vue from 'vue';
import store from './../../store';
import billProductTransformer from './../../transformers/creditNoteProduct';

const success = ({ data }, resolve) => {
  const billProducts = billProductTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllBillProducts', billProducts);
  resolve(billProducts);
};

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/bills/${id}/products`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/billProduct/all.js